import { version } from '../../package.json';

// The build id of the currently running bundle. On the client the server injects
// it as `window.__BUILD_ID__`, which is read and then deleted on boot, so we
// capture it here into a stable module value the rest of the app can read later.
// On the server we read it straight from the build-time env so server-rendered
// markup matches the client and hydration does not leave a stale value.
const initialBuildId = () => {
  if (typeof window !== 'undefined') {
    return window.__BUILD_ID__ || version;
  }
  return process.env.RAZZLE_BUILD_ID || version;
};

let runningBuildId = initialBuildId();

export const getRunningBuildId = () => runningBuildId;

export const setRunningBuildId = (id) => {
  if (id) {
    runningBuildId = id;
  }
};
